import styled from 'styled-components';

const ImageElement = styled.img`
  width: ${(props: any) => (props.height ? 'auto' : props.size ? props.size + 'px' : 'fit-content')};
  height: ${(props: any) => (props.height ? `${props.height}px` : props.size ? props.size + 'px' : 'fit-content')};
  border-radius: ${(props: any) => (props.circular ? '50' : '0')}%;
` as any;

export interface IProps extends IntrinsicProps {
  alt?: string;
  size?: number;
  src: string;
  circular?: boolean;
  /** Optional height which sets the width to auto. */
  height?: number;
  onError?: any;
  onLoad?: () => void;
}

export const Image = ({ alt, ...rest }: IProps) => {
  const a11yProps = {
    alt: alt ? alt : '',
    role: !alt ? 'presentation' : null,
  };

  return <ImageElement data-testid="Image" {...a11yProps} {...rest} />;
};
